import { io } from 'socket.io-client';

let socket = null;
let attemptedFallback = false;

// Dev:  VITE_API_URL = http://localhost:8080        → path = /socket.io  (direct to backend)
// Prod: VITE_API_URL = https://…/admin              → path = /admin/socket.io  (nginx strips /admin)
function resolveSocket(apiUrl) {
  const url = apiUrl.replace(/\/$/, '');

  if (url.endsWith('/admin')) {
    return {
      origin:     url.slice(0, -6),       // strip /admin → server root
      socketPath: '/admin/socket.io',
    };
  }

  return { origin: url, socketPath: '/socket.io' };
}

function alternateSocketPath(path) {
  return path === '/admin/socket.io' ? '/socket.io' : '/admin/socket.io';
}

export function getTrackingSocket(apiUrl) {
  // Return existing socket if it is active (connecting / connected / reconnecting).
  // socket.active is false only after explicit disconnect() or max retries exceeded.
  if (socket && socket.active) return socket;

  // If we reach here: no socket yet, or previous one is permanently gone.
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  const { origin, socketPath } = resolveSocket(apiUrl);

  console.log('[TrackingSocket] Connecting to', `${origin}/tracking`, 'path:', socketPath);

  attemptedFallback = false;

  const connectWithPath = (path) => {
    socket = io(`${origin}/tracking`, {
      path,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      timeout: 10000,
    });

    socket.on('connect', () => console.log('[TrackingSocket] ✅ Connected id:', socket.id));
    socket.on('disconnect', (r) => console.log('[TrackingSocket] 🔌 Disconnected:', r));

    socket.on('connect_error', (e) => {
      console.warn('[TrackingSocket] ❌ Error:', e.message);

      // If proxy/backend only supports the other Socket.IO path, retry once.
      if (!attemptedFallback) {
        attemptedFallback = true;
        const nextPath = alternateSocketPath(path);
        console.warn('[TrackingSocket] Retrying with socket.io path:', nextPath);
        socket.removeAllListeners();
        socket.disconnect();
        connectWithPath(nextPath);
      }
    });
  };

  connectWithPath(socketPath);

  return socket;
}

export function disconnectTrackingSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
    console.log('[TrackingSocket] Disconnected (page leave)');
  }
}
